import * as React from 'react';
import { IBikeItem } from '../../../../../bike/interfaces';
import { bikeImageSrcSet } from '../../../../../react/common/lib';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import MyBikeContainer from '../../../../../react/bike-db/containers/MyBikeContainer';
import FormattedNumber from '../../../../../react/common/components/FormattedNumber';
import MyBikeIconFilled from '../../../../../react/bike-db/components/MyBikeIconFilled';
import MyLouisService, { EMyBikeAPIEndpoint } from '../../../../../react/bike-db/services/MyLouisService';

interface IBikeItemProps {
    bike: IBikeItem;
    csrfToken: string;

    onRemove?(bikeId: string): void;
}

const BikeItemGrid: React.FunctionComponent<IBikeItemProps> = props => {
    const { bike } = props;

    const isManufactureYearDisplayed = bike.manufactureYearStart || bike.manufactureYearEnd;

    const displayManufactureYear = () => {
        if (isManufactureYearDisplayed) {
            const manufactureYearStart = (bike.manufactureYearStart > 0) ? bike.manufactureYearStart : '...';
            const manufactureYearEnd = (bike.manufactureYearEnd > 0) ? bike.manufactureYearEnd : '...';
            return `${manufactureYearStart} - ${manufactureYearEnd}`;
        }

        return <React.Fragment>&nbsp;</React.Fragment>;
    };

    return (
        <div className='bike-card'>
            <div className='bike-card-container'>
                <a className='bike-card-full-link' href={bike.url} data-qa='bike-detail-page-link' />
                <MyBikeContainer
                    myLouisService={new MyLouisService(EMyBikeAPIEndpoint.ShopSpryker)}
                    bikeId={bike.idBike.toString()}
                    externalId={bike.externalId.toString()}
                    isInMyBike={bike.isInMyBike}
                    wrapperComponent={MyBikeIconFilled}
                    onRemove={props.onRemove}
                    csrfToken={props.csrfToken}
                />

                <a className='bike-image-link' href={bike.url}>
                    <div data-fly-to-cart-object='true' className='image-blend-mode lazy-image-container' suppressHydrationWarning={true}>
                        <img
                            className='bike-thumbnail lazyload'
                            src={bike.images[0].externalUrlLarge}
                            data-src={bike.images[0].externalUrlLarge}
                            data-srcset={bikeImageSrcSet(bike.images[0].externalUrlLarge)}
                            alt={bike.marketingName}
                            suppressHydrationWarning={true}
                        />
                    </div>
                </a>
                <p className='build-year-info'>
                    {displayManufactureYear()}
                </p>
            </div>

            <div className='bike-card-info paragraph-s'>
                <div className='sub-title'>{bike.manufacturer}</div>
                <div className='title'>
                    <a href={bike.url}>
                        <span className='bike-name' data-qa='bike-marketing-name'>{bike.marketingName}</span>{bike.model}
                    </a>
                </div>
                <div className='engine-size' suppressHydrationWarning={true}><FormattedNumber number={bike.engineSize}/>&nbsp;{translate('cc', 'bike-db')}</div>
            </div>
        </div>
    );
};

export default BikeItemGrid;
